/*! @azure/msal-browser v4.5.1 2025-03-04 */
'use strict';

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
const contentError = "ContentError";
const userSwitch = "user_switch";
export { contentError, userSwitch };